import React, { useState } from "react";
import { notify } from "../../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../../Interface/CtaButton";

function NewProduitModal({
  open,
  setOpen,
  categorieName,
  categorieId,
  onSubmitAction,
  isNumeric,
  loading
}) {
  const [produitName, setProduitName] = useState("");
  const [nameError, setNameError] = useState(false);

  const handleModalClosure = () => {
    setProduitName("");
    setNameError(false);
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    const { type, message, details } = await onSubmitAction({
      produitName,
      categorieId
    });

    if (type === "success") {
      notify("success", message);
      handleModalClosure();
    } else {
      notify("error", message);
    }
  };

  const handleProduitSubmit = ({ key }) => {
    if (key === "Enter") {
      if (produitName.length > 0) handleModalSubmission();
      else setNameError(true);
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>
            Ajouter un produit dans <strong>{categorieName}</strong>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>Nom du produit</label>
          <input
            name="produit"
            type="text"
            className={`form-control ${nameError ? "has-error" : ""}`}
            onChange={({ target }) => setProduitName(target.value)}
            onKeyUp={handleProduitSubmit}
            value={produitName}
          />
          <span className={`invalid-feedback ${nameError ? "show" : ""}`}>
            Le produit doit avoir un nom valide
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton
            action={() => handleProduitSubmit({ key: "Enter" })}
            text="Ajouter"
            busy={loading}
          />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default NewProduitModal;
